export default __webpack_public_path__ + "static/anna@2x-36822183716881a46b9d4bdddcae667d.png";